import React, { useState, useEffect, useCallback } from 'react';
import { FormHandles, SubmitHandler } from '@unform/core';
import { Form } from '@unform/web';

import api from '../../../services/api';

import Input from '../../../components/FormInput';
import Select from '../../../components/SelectForm';
import Switch from '../../../components/Switch';
import Button from '../../../components/Button';

import { Container } from './styles';

interface Survey {
  name: string;
  type: string;
}

interface Project {
  projectId: number;
  name: string;
}

interface Product {
  productId: number;
  name: string;
  subGroup?: string;
  userGroups: UserGroup[];
}

interface UserGroup {
  name?: string;
  subGroups?: object[];
  structure?: object[];
}

interface Props {
  formRef: React.Ref<FormHandles>;
  buttonText: string;
  initialData?: Survey;
  handleSubmit: SubmitHandler;
  isEdit?: boolean;
  projectId?: number;
}

const FormSurvey: React.FC<Props> = props => {
  const [projects, setProjects] = useState([]);
  const [products, setProducts] = useState([]);
  const [subGroups, setSubGroups] = useState([]);
  const [useTemplate, setUseTemplate] = useState(false);
  const [isIntegrate, setIsIntegrate] = useState<boolean>(true);
  const [isDailyIntegration, setIsDailyIntegration] = useState<boolean>(false);

  const years = Array.from(
    new Array(new Date().getFullYear() - 2005 + 2),
    (val, index) => index + 2005,
  ).map((x: number) => {
    return {
      label: x.toString(),
      value: x,
    };
  });

  useEffect(() => {
    api.get('projects').then(response => {
      setProjects(
        response.data.map((project: Project) => {
          return {
            value: project.projectId,
            label: project.name,
          };
        }),
      );
    });

    api.get('products').then(response => {
      setProducts(
        response.data.map((prod: Product) => {
          return {
            value: prod.productId,
            label: prod.name,
          };
        }),
      );
    });

    api.get('subGroups').then(response => {
      setSubGroups(response.data);
    });
  }, []);

  const handleSwitchChange = useCallback(value => {
    setUseTemplate(value);
  }, []);

  const handleChangeIsIntegrate = useCallback(() => {
    setIsIntegrate(!isIntegrate);
  }, [isIntegrate]);

  const handleChangeIsDailyIntegration = useCallback(() => {
    setIsDailyIntegration(!isDailyIntegration);
  }, [isDailyIntegration]);

  return (
    <Container>
      <Form
        ref={props.formRef}
        initialData={props.initialData}
        onSubmit={props.handleSubmit}
      >
        {!props.projectId && (
          <>
            <h2>Project</h2>
            <Select name="project" options={projects} />
          </>
        )}

        <h2>Year</h2>
        <Select name="year" options={years.reverse()} />

        <h2>Name</h2>
        <Input type="text" name="name" placeholder="Enter the name" />

        <h2>Title</h2>
        <Input type="text" name="title" placeholder="Enter the title" />

        <h2>User Group</h2>
        <Select name="subGroup" options={subGroups} />

        <h2>Product</h2>
        <Select name="product" options={products} />

        <h2>Use Template</h2>

        <Switch
          name="useTemplate"
          handleSwitchChange={handleSwitchChange}
          initialValue={useTemplate}
        />

        <h2>Integrate with data warehouse</h2>
        <Switch
          name="isIntegrate"
          handleSwitchChange={handleChangeIsIntegrate}
          initialValue={isIntegrate}
        />

        <h2>Daily Integration with data warehouse</h2>
        <Switch
          name="isDailyIntegration"
          handleSwitchChange={handleChangeIsDailyIntegration}
          initialValue={isDailyIntegration}
        />

        <Button type="submit" $width="200px">
          {props.buttonText}
        </Button>
      </Form>
    </Container>
  );
};

export default FormSurvey;
